export class ComplexEnumItem<ID extends string = string> {
  /**
   * an id which should uniquely identify a complex enum item
   *
   * for best results, use a static, uppercase, UUID, especially if being saved
   * in the database
   *
   * ---
   * ## Important
   *
   * most of the time, when a {@link ComplexEnumItem} is used in conjunction with
   * a database object, we're saving the id and setting the column type to
   * `uniqueidentifier`
   *
   * when this is done, the database doesn't care if its uppercase or lowercase,
   * but when it comes out of the database, via TypeORM, it's uppercase
   *
   * @example
   * const id1 = '12CC786E-2639-42FD-B3AD-54E6AF12BD59'
   * const id2 = '66BD6DBB-25B2-4F31-B2B7-8B040933C402'
   * const id3 = '217460B6-9BBD-4817-918D-F008BBE6314C'
   */
  readonly id: ID

  constructor(id: ID) {
    this.id = id
  }
}
